import React, { Component } from "react";
import propertiesStyle from "./Properties.module.css";
import textStyles from "./Text.module.css";
import TriangleDown from "../../SVG/TriangleDown";
import TriangleRight from "../../SVG/TriangleRight";
import { setProperty as SET_PROPERTY } from "../../Scripts/PropertyUtils";
import styled from "styled-components";
import DragInput from "../DragInput/DragInput";
import Scene from "../../Scripts/PIXI/Scene";

const Select = styled.select`
  background-color: #181d25;
  color: #fff;
  padding: 4px;
  border: none;
  margin: 4px;
  border-radius: 4px;
`;

export default class Text extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colorClicked: false,
      open: false,
      font: null,
      showContext: false,
    };
  }

  drag(e, property, value) {
    e.dataTransfer.setData("property", property);
    e.dataTransfer.setData("value", value);
  }

  handleContext(e, item) {
    e.preventDefault();

    this.setState({
      showContext: true,
      mouseX: e.clientX,
      mouseY: e.clientY,
    });
    window.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(e) {
    this.setState({
      showContext: false,
    });
    window.removeEventListener("click", this.handleClick.bind(this));
  }

  updateProperty(property, value) {
    SET_PROPERTY(this.props.item, property, value);

    this.setState({ update: true });
  }

  colorClicked(e) {
    this.setState({
      colorClicked: !this.state.colorClicked,
    });
  }

  allowDrop(e) {
    e.preventDefault();
  }

  handleMouseDown(e, property, startValue) {
    this.property = property;
    this.mouseDown = true;
    var rect = document.querySelector("body").getBoundingClientRect();
    var x = e.clientX - rect.left; //x position within the element.
    this.startX = x;

    this.startValue = startValue;
    document.addEventListener("mousemove", this.handleMouseMove.bind(this));
    document.addEventListener("mouseup", this.handleMouseUp.bind(this));
  }

  handleMouseMove(e) {
    if (this.mouseDown) {
      var rect = document.querySelector("body").getBoundingClientRect();
      var x = e.clientX - rect.left; //x position within the element.
      x = x - this.startX;
      let value = this.startValue + x;

      if (this.property === "style.fontSize") {
        value = Math.max(value, 1);
      }

      this.updateProperty(this.property, value);

      this.updateProperty("text", this.props.item.text);
    }
  }

  handleMouseUp(e) {
    this.mouseDown = false;
    document.removeEventListener("mousemove", this.handleMouseMove.bind(this));
    document.removeEventListener("mouseup", this.handleMouseUp.bind(this));
  }

  handleColorChange(color, event) {
    // this.props.item.material.color = new THREE.Color(
    //   "rgba(" +
    //     color.rgb.r +
    //     "," +
    //     color.rgb.g +
    //     "," +
    //     color.rgb.b +
    //     "," +
    //     color.rgb.a +
    //     ")"
    // );
    this.forceUpdate();
  }

  drop(e, item) {
    if (e.dataTransfer.getData("source")) {
      if (!item.dataBinds) {
        item.dataBinds = [];
      }
      item.dataBinds.push({
        source: e.dataTransfer.getData("source"),
        property: e.dataTransfer.getData("property"),
        itemProperty: "text",
      });
    }
  }

  handleContextUnbind() {
    this.props.item.dataBinds = this.props.item.dataBinds.filter(
      (d) => d.itemProperty !== "text"
    );
    this.props.item.text = "";
    this.forceUpdate();
  }

  upload(e) {
    const files = Array.from(e.target.files);

    const formData = new FormData();

    files.forEach((file, i) => {
      formData.append("file", file);
    });

    let path_id = this.props.project?.use_project_folder
      ? this.props.project?._id
      : this.props.project.user._id;
    let prefix = this.props.project?.use_project_folder ? "project/" : "";

    fetch(`${window.projectServerURL}assets/fonts/${prefix}${path_id}`, {
      method: "POST",
      body: formData,
    }).then(() => {
      let font = new FontFace(
        files[0].name,
        "url('" +
          window.projectServerURL +
          "assets/fonts/" +
          prefix +
          path_id +
          "/" +
          files[0].name +
          "')"
      );
      font.load().then((loadedFont) => {
        window.document.fonts.add(loadedFont);
      });
    });
  }

  render() {
    let color = this.props.item.style ? "#" + this.props.item.style._fill : "";

    let text =
      this.props.item.dataBinds &&
      this.props.item.dataBinds.find((bind) => bind.itemProperty === "text")
        ? this.props.item.dataBinds.find((bind) => bind.itemProperty === "text")
            .property
        : this.props.item._text;
    let fonts = window.document.fonts.entries();
    let done = false;
    let font_array = [];

    while (!done) {
      const font = fonts.next();
      if (!font.done) {
        font_array.push(font.value[0]);
        // console.log(font.value[0])
      } else {
        done = font.done;
      }
    }

    return (
      <div className={propertiesStyle.Group}>
        <div
          className={propertiesStyle.GroupTitle}
          onClick={() => this.setState({ open: !this.state.open })}
        >
          <div className={propertiesStyle.Open}>
            {this.state.open && <TriangleDown />}
            {!this.state.open && <TriangleRight />}
          </div>
          <div className={propertiesStyle.Title}>Text</div>
        </div>
        {this.state.open && (
          <div className={textStyles.Group}>
            <div className={textStyles.lists}>
              <div className={textStyles.Property}>
                <label
                  className={textStyles.Y}
                  draggable={true}
                  onDragStart={(event) =>
                    this.drag(event, "text", this.props.item.text)
                  }
                >
                  Text
                </label>
                <textarea
                  rows="4"
                  cols="50"
                  value={text}
                  dir={this.props.item.rtl ? "rtl" : ""}
                  lang={this.props.item.rtl ? "ar" : ""}
                  onChange={(e) => {
                    this.updateProperty("text", e.currentTarget.value);
                  }}
                  onDrop={(event) => this.drop(event, this.props.item)}
                  onDragOver={(event) => this.allowDrop(event)}
                  onContextMenu={(e) => {
                    this.handleContext(e, this.props.item);
                  }}
                />
              </div>
            </div>
            <div className={textStyles.Property}>
              <Select
                onChange={(event) => {
                  this.setState({ font: event.target.value });
                  this.props.item.style.fontFamily = event.target.value;
                }}
                value={this.props.item.style.fontFamily}
              >
                {font_array.map((font) => {
                  return <option value={font.family}>{font.family}</option>;
                })}
              </Select>
              <div
                className={textStyles.UploadButton}
                onClick={() => document.getElementById("font-input").click()}
              >
                Upload Font
              </div>
              <input
                id="font-input"
                type="file"
                name="font"
                style={{ display: "none" }}
                onChange={(e) => {
                  this.upload(e);
                }}
              />
            </div>
            <div className={textStyles.Property}>
              <label
                className={textStyles.Y}
                draggable={true}
                onDragStart={(event) =>
                  this.drag(
                    event,
                    "style.fontSize",
                    this.props.item.style.fontSize
                  )
                }
              >
                Font Size
              </label>
              <DragInput
                min="1"
                type="number"
                value={this.props.item.style.fontSize}
                onChange={(value) => {
                  this.updateProperty("style.fontSize", parseInt(value));
                  this.updateProperty("text", this.props.item.text);
                }}
              />
            </div>

            <div className={textStyles.Property}>
              <label
                className={textStyles.Y}
                draggable={true}
                onDragStart={(event) =>
                  this.drag(
                    event,
                    "style.letterSpacing",
                    this.props.item.style.letterSpacing
                  )
                }
              >
                Letter Spacing
              </label>
              <input
                type="number"
                value={this.props.item.style.letterSpacing}
                onMouseDown={(e) => {
                  this.handleMouseDown(
                    e,
                    "style.letterSpacing",
                    this.props.item.style.letterSpacing
                  );
                }}
                onChange={(e) => {
                  this.updateProperty(
                    "style.letterSpacing",
                    parseInt(e.currentTarget.value)
                  );
                  this.updateProperty("text", this.props.item.text);
                }}
              />
            </div>
            <div className={textStyles.Property}>
              <label
                className={textStyles.Y}
                draggable={true}
                onDragStart={(event) =>
                  this.drag(
                    event,
                    "style.leading",
                    this.props.item.style.leading
                  )
                }
              >
                Line Spacing
              </label>
              <input
                type="number"
                value={this.props.item.style.leading}
                onMouseDown={(e) => {
                  this.handleMouseDown(
                    e,
                    "style.leading",
                    this.props.item.style.leading
                  );
                }}
                onChange={(e) => {
                  this.updateProperty(
                    "style.leading",
                    parseInt(e.currentTarget.value)
                  );
                  this.updateProperty("text", this.props.item.text);
                }}
              />
            </div>
            <div className={textStyles.Property}>
              <label className={textStyles.CheckboxContainer}>
                Transform Text to Uppercase
                <input
                  type="checkbox"
                  checked={
                    this.props.item.text_transform?.uppercase ? true : false
                  }
                  onChange={(e) => {
                    this.updateProperty(
                      "text_transform.uppercase",
                      e.currentTarget.checked
                    );

                    this.updateProperty("text", this.props.item.text);
                  }}
                />
                <span className={textStyles.Checkmark} />
              </label>
            </div>

            <div className={textStyles.Property}>
              <label className={textStyles.CheckboxContainer}>
                Transform Text to lowercase
                <input
                  type="checkbox"
                  checked={
                    this.props.item.text_transform?.lowercase ? true : false
                  }
                  onChange={(e) => {
                    this.updateProperty(
                      "text_transform.lowercase",
                      e.currentTarget.checked
                    );

                    this.updateProperty("text", this.props.item.text);
                  }}
                />
                <span className={textStyles.Checkmark} />
              </label>
            </div>

            <div className={textStyles.Property}>
              <label
                className={textStyles.Y}
                draggable={true}
                onDragStart={(event) =>
                  this.drag(
                    event,
                    "style.wordWrapWidth",
                    this.props.item.style.wordWrapWidth
                  )
                }
              >
                Word Wrap Width
              </label>
              <DragInput
                type="number"
                min="1"
                value={this.props.item.style.wordWrapWidth}
                onChange={(value) => {
                  this.updateProperty("style.wordWrapWidth", parseInt(value));
                  this.updateProperty("text", this.props.item.text);
                }}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "row"}}>
            <div className={textStyles.Property}>
              <label className={textStyles.CheckboxContainer}>
                Word Wrap
                <input
                  type="checkbox"
                  checked={this.props.item.style.wordWrap}
                  onChange={(e) => {
                    this.updateProperty(
                      "style.wordWrap",
                      this.props.item.style.wordWrap ? false : true
                    );
                  }}
                />
                <span className={textStyles.Checkmark} />
              </label>
            </div>
            {this.props.item.style.wordWrap === true && 
            <div className={textStyles.Property}>
              <label className={textStyles.CheckboxContainer}>
                Break Words
                <input
                  type="checkbox"
                  checked={this.props.item.style.breakWords}
                  onChange={(e) => {
                    this.updateProperty(
                      "style.breakWords",
                      this.props.item.style.breakWords ? false : true
                    );
                  }}
                />
                <span className={textStyles.Checkmark} />
              </label>
            </div>
            }
            </div>
            <div className={textStyles.Property}>
              <label className={textStyles.CheckboxContainer}>
                Centre Text when wrapping
                <input
                  type="checkbox"
                  checked={
                    this.props.item.style.align === "center" ? true : false
                  }
                  onChange={(e) => {
                    this.updateProperty(
                      "style.align",
                      e.currentTarget.checked ? "center" : "left"
                    );
                  }}
                />
                <span className={textStyles.Checkmark} />
              </label>
            </div>
            <div className={textStyles.Property}>
              <label className={textStyles.CheckboxContainer}>
                Right-to-Left
                <input
                  type="checkbox"
                  checked={this.props.item.rtl}
                  onChange={(e) => {
                    this.updateProperty("rtl", e.currentTarget.checked);
                  }}
                />
                <span className={textStyles.Checkmark} />
              </label>
            </div>
            {/* <div className={textStyles.Property}>
              <label className={textStyles.Y}>Format Time</label>
              <input
                value={this.props.item.format_time}
                onChange={(e) => {
                  this.updateProperty("format_time", e.currentTarget.value);
                  this.updateProperty("text", this.props.item.text);
                }}
              />
            </div> */}
          </div>
        )}
      </div>
    );
  }
}
